<template>
  <div class="loader-container">
    <svg class="loader" viewBox="0 0 100 100">
      <!-- Фоновый круг -->
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        stroke="#ffd5d5"
        stroke-width="10"
      />
      <!-- Анимируемая дуга с линейным градиентом -->
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        stroke="url(#gradient)"
        stroke-width="10"
        stroke-linecap="round"
        stroke-dasharray="125.6"
        stroke-dashoffset="0"
      />
      <!-- Определение линейного градиента -->
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="50%">
          <stop offset="0%" style="stop-color: #ff8c8c; stop-opacity: 1"/>
					<stop offset="100%" style="stop-color: #ffd5d5; stop-opacity: 0"/>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>



<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: white;
	background-image: url('../assets/icons/loaderBg.svg');
	background-size: 100%;
	background-repeat: no-repeat;
	padding: 8%;
  border-radius: 50%;
}

.loader {
  width: 100%;
  height: 100%;
  animation: rotate 2s linear infinite;
}

/* .loader circle:nth-child(2) {
  animation: dash 1.5s linear infinite;
	transform-origin: center;
} */

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 125.6; /* Полный круг */
  }
  50% {
    stroke-dashoffset: 62.8; /* Половина круга */
    transform: rotate(90deg); /* Добавление вращения для плавности */
  }
  100% {
    stroke-dashoffset: 0; /* Возвращение к началу */
    transform: rotate(180deg);
  }
}
</style>
